module.exports = __webpack_public_path__ + "img/clan.aa899352.png";